require('~/pegasus/templates/controls/replace_with_browse.hjs');
require('~/pegasus/templates/controls/replace_with_free_icon.hjs');
require('~/pegasus/templates/controls/replace_with_free_image.hjs');
require('~/pegasus/templates/controls/replace_with_pattern.hjs');
require('~/pegasus/templates/controls/replace_with_saved_image.hjs');

Pegasus.ReplaceImageView = Em.View.extend({
  controller: function(){
    return Pegasus.lookupController('upload');
  }.property(),
  classNames: ['vr-replace-image'],
  isVisibleBinding: 'controller.shouldShowImageReplacer',
  templateName: 'replace_image',
  exitReplacer: function(){
    this.$('.replace-overlay').removeClass('open');
    this.set('controller.errors', []);
    Em.run.later( this.get('controller'), 'set', 'shouldShowImageReplacer', false, 500);
  },
  click: function(){
    this.set('controller.errors', []);
    // reset the field so the same file will, again, generate an error
    $('#file-upload').val('');
  },
  searchSaved: Em.View.extend({
    tagName: 'a',
    classNames: 'vr-replace-with-saved-image',
    templateName: 'controls/replace_with_saved_image',
    click: function(){
      if ( this.get('controller.controllers.imageGallery.loadingControllerName') !== 'savedImages'){
        this.set('controller.controllers.imageGallery.query', '');
        this.get('controller.controllers.imageGallery').reset();
        this.set('controller.controllers.imageGallery.loadingControllerName', 'savedImages');
        this.set('controller.controllers.imageGallery.query', '');
      }
      this.get('controller.controllers.imageGallery').populateThisEmailsImages();
      this.set('controller.shouldShowImageGallery', true);
      this.get('parentView').exitReplacer();
      return false;
    }
  }),
  searchFreeIcons: Em.View.extend({
    tagName: 'a',
    classNames: 'vr-replace-with-free-icon',
    templateName: 'controls/replace_with_free_icon',
    click: function(){
      if ( this.get('controller.controllers.imageGallery.loadingControllerName') !== 'iconsImages'){
        this.set('controller.controllers.imageGallery.query', 'social');
        this.get('controller.controllers.imageGallery').reset();
        this.set('controller.controllers.imageGallery.loadingControllerName', 'iconsImages');
        this.set('controller.controllers.imageGallery.query', '');
      }
      this.set('controller.shouldShowImageGallery', true);
      this.get('parentView').exitReplacer();
      return false;
    }
  }),

  searchPatterns: Em.View.extend({
    tagName: 'a',
    classNames: 'vr-replace-with-pattern',
    templateName: 'controls/replace_with_pattern',
    click: function(){
      if ( this.get('controller.controllers.imageGallery.loadingControllerName') !== 'patternImages'){
        this.set('controller.controllers.imageGallery.query', '');
        this.get('controller.controllers.imageGallery').reset();
        this.set('controller.controllers.imageGallery.loadingControllerName', 'patternImages');
        this.set('controller.controllers.imageGallery.query', '');
      }
      this.set('controller.shouldShowImageGallery', true);
      this.get('parentView').exitReplacer();
      return false;
    }
  }),

  searchFreeImages: Em.View.extend({
    tagName: 'a',
    classNames: 'vr-replace-with-free-image',
    templateName: 'controls/replace_with_free_image',
    click: function(){
      if ( this.get('controller.controllers.imageGallery.loadingControllerName') !== 'pexelsImages'){
        this.set('controller.controllers.imageGallery.query', '');
        this.get('controller.controllers.imageGallery').reset();
        this.set('controller.controllers.imageGallery.loadingControllerName', 'pexelsImages');
      }
      this.set('controller.shouldShowImageGallery', true);
      this.get('parentView').exitReplacer();
      return false;
    }
  }),
  browseZone: Ember.View.extend({
    tagName: 'a',
    classNames: 'vr-replace-with-browse',
    viewName: 'browse',
    templateName: 'controls/replace_with_browse',
    click: function(e) {
      e.stopPropagation();
    },
  }),
  drop: function(e){
    e.stopPropagation();
    e.preventDefault();
  },
  didInsertElement: function(){
    this._super();
    var uploadController = this.get('controller'),
      sendError = function(yml){
        this.get('controller').send('notificationError', yml);
      }.bind(this);
    var fileGrabbedCallback = encodeImageFileAsURL(function(base64Img, name, size, type){
      convertToDataURLviaCanvas(base64Img, function(d){
        var data = {
          encoded: d.encoded,
          name: name,
          is_animated_gif: d.is_animated_gif
        };

        Em.run( uploadController, '_requestComplete', null, data );
      }, sendError, type, Pegasus.lookupController('toolbar').get('imageHandler.maxImageWidth'), false, size);
    });

    $('#file-upload').change(encodeImageFileAsURL);

    function handleDragOver(evt) {
      $('#drop_zone').addClass('dragged-over');
      evt.stopPropagation();
      evt.preventDefault();
      evt.dataTransfer.dropEffect = 'copy'; // Explicitly show this is a copy.
    }

    function handleDragLeave(evt) {
      $('.dragged-over').removeClass('dragged-over');
      evt.stopPropagation();
      evt.preventDefault();
    }

    // Setup the dnd listeners.
    var dropZone = document.getElementById('drop_zone');
    dropZone.addEventListener('dragover', handleDragOver, false);
    dropZone.addEventListener('dragleave', handleDragLeave, false);
    dropZone.addEventListener('drop', function(e){
      $('.dragged-over').removeClass('dragged-over');

      var context = {
        files: e.dataTransfer.files
      };

      fileGrabbedCallback.call(context);
    }, false);


    this.$('#file-upload').change(fileGrabbedCallback);

    Em.run.next(this, function(){
      this.$('.replace-overlay').addClass('open');
    });
  },

});
